module.exports = __webpack_public_path__ + "img/364-977d7b.png";